export default __webpack_public_path__ + "static/media/29_Es.8963bfb9.svg";